import styled from "styled-components";

export const VideoKycWrapper = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center; /* the card sits in the middle of the screen; a tall card just makes the page scroll */
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  color: #333;

  .container {
    max-width: 480px;
    width: 100%;
    background: #ffffff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    height: fit-content;
  }

  h2 {
    color: #0a9396;
    text-align: center;
    margin: 0 0 20px;
    font-size: 20px;
  }

  .msg {
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .msg.error {
    background: #fdecea;
    color: #b3261e;
    border-left: 4px solid #b3261e;
  }
  .msg.success {
    background: #eaf6ea;
    color: #1e6b1e;
    border-left: 4px solid #1e6b1e;
  }
  .msg.center {
    text-align: center;
    padding: 14px 16px;
    font-size: 15px;
  }

  .highlight {
    background-color: #f1f5f9;
    border-left: 4px solid #0a9396;
    padding: 12px 15px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 14px;
  }
  .highlight p {
    margin: 6px 0;
  }

  .note {
    font-size: 13px;
    color: #555;
    margin: 10px 0;
  }

  video {
    width: 100%;
    border-radius: 8px;
    background: #000;
    margin-bottom: 10px;
  }

  .timer {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    color: #e52255;
    margin-bottom: 10px;
  }

  .button-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  button {
    width: 100%;
    background: #0a9396;
    color: #fff;
    border: none;
    padding: 13px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
  }
  button:disabled {
    background: #9fbfc0;
    cursor: not-allowed;
  }
  button.secondary {
    background: #6c757d;
  }
  button.danger {
    background: #e52255;
  }

  .checklist {
    list-style: none;
    padding: 0;
    margin: 10px 0 6px;
    font-size: 14px;
  }
  .checklist li {
    padding: 5px 0;
  }

  .meter {
    height: 10px;
    background: #e3e8ee;
    border-radius: 6px;
    overflow: hidden;
    margin: 4px 0 12px;
  }
  .meter .bar {
    height: 100%;
    background: #0a9396;
    transition: width 0.12s linear;
  }

  .hint {
    font-size: 13px;
    color: #b3261e;
    margin: 4px 0 10px;
  }
`;
